import Actions from '../../odata/actions';

const actions = new Actions('approvalResponse', 'approvalResponses');

export default actions;
